import React, { useState, useEffect } from 'react';

//components
import { Conditional } from 'common/components/layout';
import { Link } from 'react-router';
import { Button, BUTTON } from 'components/common/Button/Button';
import Dropdown from 'components/common/Dropdown/Dropdown';
import { Spinner } from 'components/common/LoadingStatus/LoadingStatus';
import CreateDelegationPanel from './DelegationSidePanel/CreateDelegationPanel';
import DelegationDrawer from './DelegationSidePanel/DelegationDrawer';
import EditDelegationPanel from './DelegationSidePanel/EditDelegationPanel/EditDelegationPanel';
import SetupTask from './DelegationSidePanel/SetupTask/SetupTask';
import DelegationTable from './DelegationTable';
import DelegationTableNewDOA from './DelegationTableNewDOA';
import ActionModal from 'components/common/ActionModal/ActionModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faPlus } from '@fortawesome/free-solid-svg-icons';

//selectors
import { manageDoALogSelector } from 'common/permissions/selectors';
import { binderInstitutionIdSelector } from 'common/selectors';
import { hasBinderAccess, delegationsList } from 'pages/delegationOfAuthority/v2/selectors';

//utils
import lodash from 'lodash';
import { connect } from 'react-redux';
import { ThemeProvider } from '@material-ui/styles';
import DelegationStatement from 'pages/delegationOfAuthority/v2/components/DelegationStatement/DelegationStatement';
import { manageStudyDelegationPredicate } from 'common/permissions/studyPredicates';
import { newDoaStudyFlowAccess } from '../../../../common/features/predicates';

//styles
import styles from './DelegationOfAuthorityV2.scss';
import theme from 'complionUtil/theme';
import classnames from 'classnames';

//actions
import {
    deleteStudyDelegationV2,
    loadStudyDelegationsV2,
    unloadStudyTasksAndDelegationsV2,
} from 'pages/delegationOfAuthority/v2/actions/studyDelegationsV2';
import { loadStudyRolesV2 } from 'pages/delegationOfAuthority/v2/actions/studyRolesV2';
import { loadSignatureExpectationsV2 } from 'pages/delegationOfAuthority/v2/actions/studySignaturesV2';
import { loadStudyTasksV2, loadStudyTasksForExportV2 } from 'pages/delegationOfAuthority/v2/actions/studyTasksV2';
import {
    exportAuditLogV2,
    exportDOAV2Frontend
} from 'pages/delegationOfAuthority/v2/actions/studyAuditLogV2';
import { exportDOAV2Backend } from 'pages/delegationOfAuthority/v2/actions/doaExportActions';
import {
    editStudyTeamMember,
    getTeamMembersByInstitution
} from 'pages/studyOverview/actions/studySettings';
import { loadStudyTeam } from 'pages/delegationOfAuthority/v2/actions/studyTeam';
import { getStudyTestamentsForInstitution } from 'pages/delegationOfAuthority/actions/studyTestaments';


function DelegationOfAuthorityV2(props) {
    const [isOpenMessage, setOpenMessage] = useState(false);
    const [createDOAOpen, handleCreateDOAOpen] = useState(false);
    const showSetupTasks = props.location.query.showSetupTasks ? Boolean(props.location.query.showSetupTasks) : false;
    const [isOpenSidePanel, setOpenSidePanel] = React.useState(showSetupTasks);
    const [showModal, setShowModal] = useState(false);

    const [editDOAOpen, handleEditDOAOpen] = useState(false);
    const [isOpenEditPanel, setOpenEditPanel] = useState(false);
    const [isNewEditPanelOpen, setIsNewEditPanelOpen] = useState(false);

    const [isBinderTab, setIsBinderTab] = useState(false);

    useEffect(() => {
        setIsBinderTab(location.pathname.includes('/binder') && true);
    });

    useEffect(() => {
        const {
            loadStudyTasksV2,
            loadStudyDelegationsV2,
            loadSignatureExpectationsV2,
            unloadStudyTasksAndDelegationsV2,
            loadStudyRolesV2,
            loadStudyTeam,
            getTeamMembersByInstitution,
            getStudyTestamentsForInstitution,
            loadStudyTasksForExportV2
        } = props;
        const binderId = lodash.get(props, ['binder', 'id']);
        const institutionId = lodash.get(props, ['institutionId']);
        const studyId = lodash.get(props, ['study', 'id'], null);

        collapseSidebar(true);

        if (binderId) {
            if (studyId) {
                loadSignatureExpectationsV2(binderId, studyId);
                loadStudyTasksV2(binderId, studyId);
                loadStudyDelegationsV2(binderId, studyId);
                loadStudyTeam(studyId, institutionId);
                getTeamMembersByInstitution(institutionId);
                loadStudyTasksForExportV2(binderId, studyId);
            }
            else {
                loadSignatureExpectationsV2(binderId);
                loadStudyTasksV2(binderId);
                loadStudyDelegationsV2(binderId);
                loadStudyTasksForExportV2(binderId);
            }
        }


        if (institutionId) {
            loadStudyRolesV2(institutionId);
            getStudyTestamentsForInstitution(institutionId);
        }
        return () => {
            unloadStudyTasksAndDelegationsV2();
            collapseSidebar(false);
        };
    }, [lodash.get(props, ['binder', 'id'], lodash.get(props, ['institutionId']))]);

    const collapseSidebar = (value) => {
        const { setSidebarCollapsed } = props;
        if (lodash.isFunction(setSidebarCollapsed)) {
            setSidebarCollapsed(value);
        }
    };

    const onDelete = () => setShowModal(true);

    const handleOnConfirmDelete = () => {
        const {
            deleteStudyDelegationV2,
        } = props;
        const delegationId = lodash.get(editDOAOpen, 'id', null);
        const binderId = lodash.get(props, 'binder.id', null);
        const studyId = lodash.get(props, 'study.id', null);

        setShowModal(false);
        setOpenEditPanel(false);

        deleteStudyDelegationV2(delegationId, binderId, studyId);
    };


    const RemoveDelegationModal = () => {
        if (!showModal) {
            return null;
        }

        return (
            <ActionModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                onSave={handleOnConfirmDelete}
            >
                Are you sure you want to delete this delegation record?
            </ActionModal >
        );
    };

    const exportDOALogBackend = () => {
        // New backend PDF generation
        props.exportDOAV2Backend(props.institutionId, props.binder.id, props.study.id);
    };

    const exportDOALogFrontend = () => {
        // Legacy frontend PDF generation using DoAExportV2
        props.exportDOAV2Frontend(props.institutionId, props.binder.id, props.study.id);
    };

    // Default export function (uses backend) for backwards compatibility
    const exportDOALog = exportDOALogBackend;

    // Dropdown options for export
    const exportOptions = [
        {
            text: 'Export (New Backend)',
            action: exportDOALogBackend,
            description: 'Uses new backend PDF generation'
        },
        {
            text: 'Export (Legacy Frontend)',
            action: exportDOALogFrontend,
            description: 'Uses legacy frontend PDF generation'
        }
    ];

    const handleCreateDelegation = () => {
        if (!props.study.id && !props.isNewDoaEnabled) {
            handleCreateDOAOpen(true);
        }
        else {
            setOpenMessage(true);
        }
    };

    const renderActionSection = () => {
        const atInitialState = lodash.get(props, ['doaStudyTasks', 'length']) === 0;
        const { canManageDoA } = props;

        return (
            <section className={
                classnames(
                    styles.ActionSection,
                    { [styles.ActionSectionStudy]: props.study.id }
                )
            }>
                <div className={styles.ActionLeftSide}>
                    <Conditional condition={canManageDoA}>
                        <Button
                            bgcolor={atInitialState ? BUTTON.BGCOLOR.CLEAR : BUTTON.BGCOLOR.BLUE}
                            outline={
                                atInitialState ? BUTTON.OUTCOLOR.LIGHTGREY : BUTTON.OUTCOLOR.NONE
                            }
                            color={atInitialState ? BUTTON.COLOR.BLACK : BUTTON.COLOR.WHITE}
                            disabled={atInitialState}
                            onClick={handleCreateDelegation}
                        >
                            Create Delegation
                        </Button>
                    </Conditional>
                </div>
                <div className={styles.ActionRightSide}>
                    <Conditional condition={!atInitialState && canManageDoA}>
                        <Button
                            outline={BUTTON.OUTCOLOR.LIGHTGREY}
                            bgcolor={BUTTON.BGCOLOR.CLEAR}
                            color={BUTTON.COLOR.BLACK}
                            onClick={() => setOpenSidePanel(true)}
                        >
                            Setup Study Tasks
                        </Button>
                    </Conditional>
                    <Dropdown
                        activeText="Export Delegation"
                        disabled={atInitialState}
                        items={exportOptions.map(option => ({
                            text: option.text,
                            title: option.description,
                            onClick: option.action
                        }))}
                    />
                </div>
            </section>
        );
    };

    const renderInitialState = () => {
        const { canManageDoA } = props;

        return (
            <Conditional condition={canManageDoA}>
                <DelegationStatement className={
                    classnames(
                        styles.InitialStatement,
                        { [styles.InitialStatementStudy]: props.study.id }
                    )
                }>
                    <p>Before you can delegate staff you’ll need to setup tasks for this study.</p>
                    <Button
                        bgcolor={BUTTON.BGCOLOR.BLUE}
                        color={BUTTON.COLOR.WHITE}
                        onClick={() => setOpenSidePanel(true)}
                    >
                        Setup Study Tasks
                    </Button>
                </DelegationStatement>
            </Conditional>
        );
    };
    const renderInitialStateV2 = () => {
        const { canManageDoA } = props;
        const atInitialState = lodash.get(props, ['doaStudyTasks', 'length']) === 0;

        return (
            <Conditional condition={canManageDoA}>
                <Conditional condition={props.isNewDoaEnabled && isOpenMessage}>
                    <DelegationDrawer open={isOpenMessage} onCancel={() => setOpenMessage(false)} />
                </Conditional>
                <DelegationStatement className={styles.newInitialStateContainer}>
                    <div className={styles.centeredContainer}>
                        <p>Delegations have not yet been assigned for this Study.</p>
                        <div className={styles.buttonContainer}>
                            <Button
                                bgcolor={BUTTON.BGCOLOR.BLUE}
                                color={BUTTON.COLOR.WHITE}
                                onClick={handleCreateDelegation}
                                disabled={atInitialState}
                            >
                                <FontAwesomeIcon icon={faPlus} className={styles.actionIcon} />
                                Add Delegation
                            </Button>
                            <Button
                                outline={BUTTON.OUTCOLOR.LIGHTGREY}
                                bgcolor={BUTTON.BGCOLOR.CLEAR}
                                color={BUTTON.COLOR.BLACK}
                                onClick={() => setOpenSidePanel(true)}
                                className={styles.responsibilitiesButton}
                            >
                                <FontAwesomeIcon icon={faList} className={styles.actionIcon} />
                                Set Up Responsibilities
                            </Button>
                        </div>
                    </div>
                </DelegationStatement>
            </Conditional>
        );
    };



    const renderTableSection = () => {
        const atInitialState = lodash.get(props, ['doaStudyTasks', 'length']) === 0;
        if (atInitialState && !props.isNewDoaEnabled) {
            return renderInitialState();
        }
        if ((!props.doaStudyDelegations || (props.doaStudyDelegations === null || props.doaStudyDelegations.length === 0)) && props.isNewDoaEnabled) {
            return renderInitialStateV2();
        }

        const {
            doaStudyDelegations,
            canManageDoA,
            doaMode,
            signatureExpectationsAll,
            institutionTimezone,
            isNewDoaEnabled
        } = props;

        const shouldUpdateComparative = [
            lodash.get(signatureExpectationsAll, 'length'),
            lodash.get(doaStudyDelegations, 'length'),
        ].join(':');

        const changeSidePanelState = () => {
            setOpenSidePanel(true);
        };

        return (
            <React.Fragment>
                <Conditional condition={isOpenMessage && !isNewDoaEnabled}>
                    {renderDoaMessage()}
                </Conditional>
                {
                    isNewDoaEnabled && isOpenMessage && (
                        <DelegationDrawer open={isOpenMessage} onCancel={() => setOpenMessage(false)} />
                    )
                }
                <section className={styles.TableSection}>
                    <Conditional condition={isNewDoaEnabled}>
                        <DelegationTableNewDOA
                            isBinderTab={isBinderTab}
                            key={shouldUpdateComparative}
                            signatureExpectationsAll={signatureExpectationsAll}
                            delegationMode={doaMode}
                            canManageDoALog={canManageDoA}
                            onRowClick={(data) => {
                                handleEditDOAOpen(data);
                                setIsNewEditPanelOpen(true);
                            }}
                            timezone={institutionTimezone}
                            studyId={props.study.id}
                            studyTeam={props.studyTeam}
                            pathname={props.location.pathname}
                            exportAuditLogV2={exportDOALog}
                            exportDOAV2Backend={exportDOALogBackend}
                            exportDOAV2Frontend={exportDOALogFrontend}
                            setOpenSidePanel={changeSidePanelState}
                            createDelegation={handleCreateDelegation}
                            institutionId={props.institutionId}
                        />
                    </Conditional>
                    <Conditional condition={!isNewDoaEnabled}>
                        <DelegationTable
                            key={shouldUpdateComparative}
                            signatureExpectationsAll={signatureExpectationsAll}
                            delegationMode={doaMode}
                            delegations={doaStudyDelegations}
                            canManageDoALog={canManageDoA}
                            onRowClick={(data) => {
                                handleEditDOAOpen(data);
                                setOpenEditPanel(true);
                            }}
                            timezone={institutionTimezone}
                            studyId={props.study.id}
                            studyTeam={props.studyTeam}
                            pathname={props.location.pathname}
                            exportAuditLogV2={exportDOALog}
                            setOpenSidePanel={changeSidePanelState}
                            createDelegation={handleCreateDelegation}
                        />
                    </Conditional>
                </section>
            </React.Fragment>
        );
    };

    const renderDoaMessage = () => {
        const { study } = props;

        return (
            <DelegationStatement className={styles.DoaMessage}>
                <p>In order to add more staff to the delegation log, please add them as Study Team Members first and then they will auto-populate to the log.</p>
                <Link
                    to={`/study/${study.id}/settings/team`}
                    className={styles.DoaMessage__button}
                >
                    Go to Study Team
                </Link>
                <i className={styles.CloseIcon} onClick={() => setOpenMessage(false)}>
                    close
                </i>
            </DelegationStatement>
        );
    };

    const renderSidePanels = () => {
        return (
            <React.Fragment>
                {
                    createDOAOpen && (
                        <CreateDelegationPanel
                            open={createDOAOpen}
                            onClose={() => handleCreateDOAOpen(false)}
                        />
                    )
                }
                <SetupTask
                    open={isOpenSidePanel}
                    onClose={() => {
                        setOpenSidePanel(false);
                    }}
                />
                {
                    isOpenEditPanel && (
                        <EditDelegationPanel
                            data={editDOAOpen}
                            studyTeam={props.studyTeam}
                            open={isOpenEditPanel}
                            onClose={() => setOpenEditPanel(false)}
                            onEdit={(user, type, studyRoleId) =>
                                props.editStudyTeamMember(user, type, studyRoleId)
                            }
                            onDelete={onDelete}
                        />
                    )
                }

                {
                    isNewEditPanelOpen && (
                        <DelegationDrawer
                            data={editDOAOpen}
                            studyTeam={props.studyTeam}
                            open={isNewEditPanelOpen}
                            onCancel={() => setIsNewEditPanelOpen(false)}
                            onEdit={(user, type, studyRoleId) =>
                                props.editStudyTeamMember(user, type, studyRoleId, false, false)
                            }
                            onDelete={onDelete}
                        />
                    )
                }
                <RemoveDelegationModal />
            </React.Fragment>
        );
    };

    if (props.doaLoading) {
        return <Spinner actionLabel={'Loading'} itemName={'Delegation Of Authority'} />;
    }

    return (
        <ThemeProvider theme={theme}>
            <main className={styles.Container}>
                <Conditional condition={!props.isNewDoaEnabled}>
                    {renderActionSection()}
                </Conditional>
                {renderTableSection()}
                {renderSidePanels()}
            </main>
        </ThemeProvider>
    );
}
export default connect(
    (state, props) => {
        const doaLoading = lodash.get(state, 'app.loadingStudyDelegations', false);
        const binder = lodash.get(state, 'binder', {});
        const me = lodash.get(state, 'me', {});
        const doaStudyTasks = lodash.get(state, 'doaStudyTasks', []);
        const binderUsers = hasBinderAccess(state);
        const doaStudyDelegations = delegationsList(state);
        const signatureExpectationsAll = lodash.get(state, 'doaSignatureExpectations', []);
        const doaRoles = lodash.get(state, 'doaRoles', []);
        const institutionId = binderInstitutionIdSelector(state);
        const doaMode = lodash.get(me, 'isInstitutionCentralized') === 'true' ? 'CENTRAL' : 'STANDARD';
        const institutionTimezone = lodash.get(me, 'institutionTimezone', 'Z');
        const study = lodash.get(state, 'study', {});
        const studyTeamOld = lodash.get(state, 'studyTeam', []);
        const studyTeam = studyTeamOld.studyTeamMember ? studyTeamOld.studyTeamMember : studyTeamOld;
        const studySettings = lodash.get(state, 'studySettings');

        const { setSidebarCollapsed } = props;
        const isNewDoaEnabled = newDoaStudyFlowAccess(state);
        const canManageDoALog = manageDoALogSelector(state);
        const canManageStudyDoA = manageStudyDelegationPredicate(state);

        return {
            doaLoading,
            binder,
            me,
            doaStudyTasks,
            signatureExpectationsAll,
            doaStudyDelegations,
            doaRoles,
            doaMode,
            institutionId,
            binderUsers,
            institutionTimezone,
            setSidebarCollapsed,
            study,
            studyTeam,
            studySettings,
            canManageDoA: study.id ? canManageStudyDoA : canManageDoALog,
            isNewDoaEnabled
        };
    },
    {
        deleteStudyDelegationV2,
        loadStudyTasksV2,
        loadStudyDelegationsV2,
        loadSignatureExpectationsV2,
        unloadStudyTasksAndDelegationsV2,
        loadStudyRolesV2,
        exportAuditLogV2,
        exportDOAV2Backend,
        exportDOAV2Frontend,
        editStudyTeamMember,
        loadStudyTeam,
        getTeamMembersByInstitution,
        getStudyTestamentsForInstitution,
        loadStudyTasksForExportV2
    }
)(DelegationOfAuthorityV2);